module.exports = __webpack_public_path__ + "static/media/blue_white1.a2a296bf.jpg";